import { CheckCircle } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SuccessAlert = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" spacing="0.5rem">
      <CheckCircle color="success" />
      <Typography>{t('COMMON.FSP.CONNECTION_TEST.TRUE')}</Typography>
    </Stack>
  );
};
